import { useMemo } from "react";
import { settingsNavItems, type SettingsNavItem } from "@/components/settings/settings-nav-config";
import { useHasRootPriviliges } from "@/hooks/auth/use-has-root-priviliges";
import { useEntityPermissionsMap } from "@/hooks/schema/use-my-permissions";

/** Settings items the current user may see, per each item's `access`. */
export const useVisibleSettingsNavItems = (): SettingsNavItem[] => {
  const { hasRootPriviliges } = useHasRootPriviliges();
  const { entityPermissionsMap } = useEntityPermissionsMap();

  return useMemo(() => {
    if (hasRootPriviliges) return settingsNavItems;
    const canReadAny = [...entityPermissionsMap.values()].some((p) => p.has_read);
    return settingsNavItems.filter(
      (item) => item.access === "everyone" || (item.access === "readers" && canReadAny),
    );
  }, [hasRootPriviliges, entityPermissionsMap]);
};
